import { Subscription } from 'rxjs';

/**
 * Collects subscriptions that will be disposed upon route change (handled by the MenuService)
 */
export class AutomaticallyDisposedSubscriptions {
  private static subscriptions: Subscription[] = [];

  static dispose() {
    for (let subscription of this.subscriptions) {
      subscription.unsubscribe();
    }

    AutomaticallyDisposedSubscriptions.subscriptions = [];
  }

  static push(subscription: Subscription) {
    AutomaticallyDisposedSubscriptions.subscriptions.push(subscription);
  }
}
